var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BaseManagementService } from '@/services/base-management-service';
import { injectable } from 'inversify';
var CarrierService = /** @class */ (function (_super) {
    __extends(CarrierService, _super);
    function CarrierService() {
        var _this = _super.call(this, "/api/v1/management/carrier") || this;
        _this.dispatchDeskPrefix = 'D_';
        _this.carrierPrefix = 'C_';
        _this.carrierGroupPrefix = 'G_';
        return _this;
    }
    CarrierService.prototype.getDefault = function () {
        return {
            id: null,
            name: '',
            groupId: '',
            isHorizonEnabled: false,
            apiPassword: '',
            notes: '',
            isDeleted: false,
            status: 'A',
            desks: [
                {
                    id: '',
                    name: '',
                    email: '',
                    snapshotTime: '',
                    status: '',
                    isDefault: true,
                },
            ],
        };
    };
    CarrierService.prototype.getBlankDispatchDesk = function () {
        return {
            id: '',
            name: '',
            email: '',
            snapshotTime: '',
            status: '',
            isDefault: false,
        };
    };
    /**
     * Get all carriers
     * @param includeDeleted true = include deleted carriers
     */
    CarrierService.prototype.all = function (includeDeleted, includeAllFilter) {
        if (includeDeleted === void 0) { includeDeleted = true; }
        if (includeAllFilter === void 0) { includeAllFilter = false; }
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, responseMessage, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/getallcarriers';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {
                                IncludeDeleted: includeDeleted,
                            })];
                    case 2:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            // dynamically add an ALL option
                            if (includeAllFilter) {
                                responseMessage.data.unshift({ name: 'ALL', id: null });
                            }
                            return [2 /*return*/, responseMessage.data];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error("Unable to get carriers");
                        console.error(error_1);
                        return [2 /*return*/, []];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CarrierService.prototype.getCarrierById = function (id) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, data, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        endpoint = '/getcarrierbyid';
                        return [4 /*yield*/, _super.prototype.getById.call(this, id, endpoint)];
                    case 1:
                        response = _a.sent();
                        if (response.success) {
                            data = __assign({}, response.data);
                            // set the first desk to be the default / central dispatch desk
                            if (data.desks.length > 0) {
                                data.desks[0].isDefault = true;
                            }
                            return [2 /*return*/, data];
                        }
                        else {
                            throw new Error(response.message);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.error('Unable to get carrier');
                        console.error(error_2);
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CarrierService.prototype.save = function (carrier) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, data, response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/savecarrier';
                        data = __assign({}, carrier);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {
                                CarrierGroupId: data.groupId,
                                CarrierId: data.id,
                                Name: data.name,
                                IsHorizonEnabled: data.isHorizonEnabled,
                                ApiPassword: data.apiPassword,
                                Notes: data.notes,
                                DefaultDispatchDeskId: data.desks[0].id,
                                DefaultDispatchDeskStatus: data.desks[0].status,
                                DefaultDispatchDeskEmail: data.desks[0].email,
                                DefaultDispatchDeskSnapshotTime: data.desks[0].snapshotTime,
                            })];
                    case 2:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response.data];
                        }
                        else {
                            throw new Error('Unable to save carrier');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        console.error('Unable to save carrier');
                        console.error(error_3);
                        throw error_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CarrierService.prototype.getAllDispatchDesks = function (includeDeleted, includeAllFilter) {
        if (includeDeleted === void 0) { includeDeleted = true; }
        if (includeAllFilter === void 0) { includeAllFilter = false; }
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, responseMessage, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/getallcarrierdispatchdesks';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {
                                IncludeDeleted: includeDeleted,
                            })];
                    case 2:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            // dynamically add an ALL option
                            if (includeAllFilter) {
                                responseMessage.data.unshift({ name: 'ALL', id: null });
                            }
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _a.sent();
                        console.error("Unable to get carriers");
                        console.error(error_4);
                        throw error_4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CarrierService.prototype.getDefaultDispatchDesk = function (siteId, materialTypeId) {
        if (materialTypeId === void 0) { materialTypeId = 'D'; }
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, responseMessage, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/getdefaultdispatchdesk';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {
                                SiteId: siteId,
                                MaterialTypeId: materialTypeId,
                            })];
                    case 2:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_5 = _a.sent();
                        console.error("Unable to get default carrier");
                        console.error(error_5);
                        throw error_5;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CarrierService.prototype.saveDispatchDesk = function (dispatchDesk, sapId) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, data, response, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/savecarrierdispatchdesk';
                        data = __assign({}, dispatchDesk);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {
                                SAPId: sapId,
                                CarrierDispatchDeskId: data.id,
                                ParentId: data.parentId,
                                Name: data.name,
                                Email: data.email,
                                SnapshotTime: data.snapshotTime,
                                Status: data.status,
                            })];
                    case 2:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response.data];
                        }
                        else {
                            throw new Error('Unable to save dispatch desk');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_6 = _a.sent();
                        console.error('Unable to save dispatch desk');
                        console.error(error_6);
                        throw error_6;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CarrierService.prototype.deleteCarrier = function (carrier) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.deleteItemById(carrier.id, '/deletecarrier')];
            });
        });
    };
    CarrierService.prototype.deleteDispatchDesk = function (dispatchDesk) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.deleteItemById(dispatchDesk.id, '/deletecarrierdispatchdesk')];
            });
        });
    };
    CarrierService.prototype.restoreCarrier = function (unFlattenedCarrier) {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint, response, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/restorecarrier';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {
                                CarrierIds: unFlattenedCarrier.carriers,
                                CarrierDispatchDeskIds: unFlattenedCarrier.desks,
                            })];
                    case 2:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response.data];
                        }
                        else {
                            throw new Error('Unable to restore carrier');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_7 = _a.sent();
                        console.error('Unable to restore carrier');
                        console.error(error_7);
                        throw error_7;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CarrierService.prototype.restoreDispatchDesk = function (dispatchDesk) {
        return __awaiter(this, void 0, void 0, function () {
            var endpoint, response, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/restorecarrierdispatchdesk';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {
                                CarrierDispatchDeskIds: [dispatchDesk.id],
                            })];
                    case 2:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response.data];
                        }
                        else {
                            throw new Error('Unable to restore dispatch desk');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_8 = _a.sent();
                        console.error('Unable to restore dispatch desk');
                        console.error(error_8);
                        throw error_8;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CarrierService.prototype, "canEditCarriers", {
        get: function () {
            return _super.prototype.canEditPage.call(this, 'CARRIERMGMT');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CarrierService.prototype, "canViewHorizonApiSection", {
        get: function () {
            return _super.prototype.canViewPage.call(this, 'LOCO');
        },
        enumerable: false,
        configurable: true
    });
    CarrierService.prototype.getValidationRules = function () {
        return {
            id: { required: true, max: 6, alpha_num: true, min: 6, regex: '^(4)([a-zA-Z0-9]{5})$' },
            name: { required: true, max: 30 },
            email: { required: true, email: true },
            snapshotTime: { required: true },
            status: { required: true },
            horizonEnabled: { required: true },
            apiPassword: { max: 40 },
            note: { max: 500 },
            deskname: { required: true, max: 100 },
        };
    };
    /**
     * Unflatten the single collection of selected carriers
     * in to their own properties
     * e.g ['C_1', 'G_2', 'D_12345']
     * @param carriers string[]
     */
    CarrierService.prototype.unFlattenCarriersCollection = function (carriers) {
        var _this = this;
        var flattenedCarriers = {};
        // add the dispatch desks
        flattenedCarriers.desks = carriers
            .filter(function (item) { return item.startsWith(_this.dispatchDeskPrefix); })
            .map(function (item) { return item.replace(_this.dispatchDeskPrefix, ''); })
            .filter(function (item) { return item !== '0'; });
        // add the carriers
        flattenedCarriers.carriers = carriers
            .filter(function (item) { return item.startsWith(_this.carrierPrefix); })
            .map(function (item) { return item.replace(_this.carrierPrefix, ''); })
            .filter(function (item) { return item !== '0'; });
        flattenedCarriers.groups = carriers
            .filter(function (item) { return item.startsWith(_this.carrierGroupPrefix); })
            .map(function (item) { return item.replace(_this.carrierGroupPrefix, ''); })
            .filter(function (item) { return item !== '0'; });
        return flattenedCarriers;
    };
    /**
     * Flatten the multiple collections in to one collection
     * e.g carrierParentIds = ['1'], carrierGroupIds = ['2'], carrierIds = ['12345']
     * gets converted to ['C_1', 'G_2', 'D_12345']
     * @param unFlattenedCarrier Unflattened carrier
     */
    CarrierService.prototype.flattenCarriersCollection = function (unFlattenedCarrier) {
        var _this = this;
        // reset carriers collection
        var flattenedCarriers = [];
        // add the dispatch desks
        unFlattenedCarrier.desks
            .map(function (item) { return "" + _this.dispatchDeskPrefix + item; })
            .forEach(function (item) { return flattenedCarriers.push(item); });
        // add the carriers
        unFlattenedCarrier.carriers
            .map(function (item) { return "" + _this.carrierPrefix + item; })
            .forEach(function (item) { return flattenedCarriers.push(item); });
        // add the carrier groups
        unFlattenedCarrier.groups
            .map(function (item) { return "" + _this.carrierGroupPrefix + item; })
            .forEach(function (item) { return flattenedCarriers.push(item); });
        return flattenedCarriers;
    };
    CarrierService.prototype.canDeleteCarrier = function (carrier) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.canDeleteItemById(carrier.id, '/candeletecarrier')];
            });
        });
    };
    CarrierService.prototype.canDeleteDispatchDesk = function (dispatchDesk) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.canDeleteItemById(dispatchDesk.id, '/candeletecarrierdispatchdesk')];
            });
        });
    };
    CarrierService.prototype.canDeleteItemById = function (id, endpoint) {
        return __awaiter(this, void 0, Promise, function () {
            var response, responseMessage, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, { Id: id })];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            return [2 /*return*/, responseMessage.data];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_9 = _a.sent();
                        console.error("Unable to check if can be deleted");
                        console.error(error_9);
                        throw error_9;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CarrierService.prototype.deleteItemById = function (id, endpoint) {
        return __awaiter(this, void 0, Promise, function () {
            var response, responseMessage, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, { Id: id })];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            return [2 /*return*/, responseMessage.data];
                        }
                        else {
                            throw new Error('Unable to delete');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_10 = _a.sent();
                        console.error('Unable to delete');
                        console.error(error_10);
                        throw error_10;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CarrierService = __decorate([
        injectable(),
        __metadata("design:paramtypes", [])
    ], CarrierService);
    return CarrierService;
}(BaseManagementService));
export { CarrierService };
